import styled from 'styled-components';
import { CaptionMixin, SitemapMixin } from '@qover/typography';

export const FooterContainer = styled.footer`
  ${CaptionMixin};
  background-color: ${({ theme }) => theme.colors.footerBackground()};
  color: ${({ theme }) => theme.colors.footerText()};
  padding: 10px;
  .markdown {
    max-width: 1040px;
    margin: 0 auto;
    a {
      color: ${({ theme }) => theme.colors.footerText()};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .markdown > p:last-child {
    margin-bottom: 0;
  }

  .language {
    ${SitemapMixin};
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1040px;
    > div + div {
      margin-top: 10px;
    }
    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      > div + div {
        margin-top: 0;
      }
    }

    form {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 20px;
    }

    img {
      background-color: #fff;
      border-radius: 1.3px;
      border: solid 0.5px ${props => props.theme.colors.textQuote(0.2)};
      box-sizing: content-box;
      height: 8px;
      margin-left: 4px;
      padding: 5px 6px;
      width: 18px;
    }
    img:first-of-type {
      margin-left: 10px;
    }
  }
  @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.minWidth.XS}) {
    padding: 20px;
  }
  @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.minWidth.S}) {
    padding: 20px 40px;
  }

  &.showBottomNav {
    padding-bottom: 150px;
    @media screen and (min-width: ${({ theme }) =>
        theme.breakpoints.minWidth.XS}) {
      padding-bottom: 120px;
    }
  }
`;
